import { fiscalPrecinctApi } from "../../api";

const FiscalPrecinctService = {
  fetchDropdown: async (term: string) => {
    const response = await fiscalPrecinctApi.fetchCustom(`/search?term=${term}`);
    return response.data;
  },
};

export default FiscalPrecinctService;
